<template>
  <div class="app-container" :style="'height: ' + windowHeight + 'px;'">
    <el-card class="box-card">
      <div class="friend-wrapper">
        <user-vue :serviceInfo="serviceInfo" />
        <search />
        <!-- REQ-2026-574277 §4：待审核计数 / 筛选 / 只看我的 -->
        <ai-review-bar />
        <!-- §10.4 最小统计：左栏很窄，只放一行「今日」摘要，悬停看今日/近7天完整对照 -->
        <ai-cs-stats compact />
        <chat-list-vue />
      </div>
    </el-card>
    <el-card class="box-card message-box">
      <div class="friendinfo">
        <message-vue :windowHeight="windowHeight" :serviceInfo="serviceInfo" />
        <text-vue :serviceInfo="serviceInfo" />
      </div>
    </el-card>
  </div>
</template>

<script>
import chatListVue from './components/chatList.vue'
import messageVue from './components/message.vue'
import search from './components/search'
import textVue from './components/text.vue'
import userVue from './components/user.vue'
import aiReviewBar from './components/aiReviewBar.vue'
import AiCsStats from '@/components/AiCsStats'
import custServiceStaffApi from '@/api/customer/custServiceStaff'
import { imIdRawParts } from '@/utils/imId'
export default {
  components: {
    search,
    userVue,
    chatListVue,
    messageVue,
    textVue,
    aiReviewBar,
    AiCsStats
    // friendlist,
    // info
  },
  data() {
    return {
      windowHeight: 0,
      serviceInfo: null
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 50;
    // ⚠️ 必须用具名 handler 并在 beforeDestroy 里 $off：$EventBus 是全局的，
    //    用匿名函数注册就没法解绑，反复进出本页会越积越多（BUG-2026-332444）。
    this.$EventBus.$on('getUserId', this.getUserInfo)
  },
  beforeDestroy() {
    this.$EventBus.$off('getUserId', this.getUserInfo)
  },
  methods: {
    getUserInfo(ids) {
      // ids 是客服自己的 IM 账号 ID（userId_客服id_40），要取中间那段客服 id。
      // 原来靠两次 substr 数下划线，非生产环境 ID 前面多一段环境前缀就整体错位，
      // 取到的是 userId，fetchById 拿这个去查客服直接 522。
      const parts = imIdRawParts(ids)
      const id = parts.length > 1 ? parts[1] : ''
      // 只有正整数才是真实的客服 id。
      // ⚠️ 不能只写 `if (!id) return`：服务端给**没有客服身份的管理员**拼的 IM 账号是 `<uid>_0_40`
      //    （IMController_TEE.proLoginForKeFu 里的哨兵，staffId 固定 0），
      //    而字符串 '0' 在 JS 里是真值，会照样拿去查客服详情 → 后端按未删除查不到 → 522「记录未找到」。
      //    管理员本来就没有客服档案，这里直接不查，页面其余部分不受影响。
      if (!/^[1-9]\d*$/.test(id)) return
      custServiceStaffApi.fetchById(id).then((res) => {
        this.serviceInfo = res.data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  display: flex;
  // width: 800px;
  .friend-wrapper {
    width: 420px;
    height: 100%;
  }
  .message-box {
    width: calc(100% - 420px);
  }
  .friendinfo {
    position: relative;
    height: 100%;
    flex: 1;
  }
}
::v-deep .el-card__body {
  padding: 0;
  height: 100%;
}
</style>